module.exports = __webpack_public_path__ + "img/cn-pro-1-t.78604047.png";